/* NZS Category Spotlight — interactive carousel.
 * Hydrates from the Liquid-rendered DOM (no hardcoded data).
 * Each [data-cspot] root holds .cspot-name / .cspot-slide / .cthumb (each [data-i])
 * plus an optional .bar progress element. Reads data-autoplay / data-interval. */
(function () {
  'use strict';
  function init(root) {
    var names  = root.querySelectorAll('.cspot-name');
    var slides = root.querySelectorAll('.cspot-slide');
    var thumbs = root.querySelectorAll('.cthumb');
    var bar    = root.querySelector('.bar');
    if (!names.length) return;
    var auto = root.getAttribute('data-autoplay') !== 'false';
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var INT  = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var cur = 0, timer = null;
    function canAuto() { return auto && !(reduce && reduce.matches); }

    function setBar() {
      if (!bar) return;
      bar.style.transition = 'none'; bar.style.width = '0%'; void bar.offsetWidth;
      if (canAuto()) { bar.style.transition = 'width ' + INT + 'ms linear'; bar.style.width = '100%'; }
    }
    function set(i) {
      cur = i;
      names.forEach(function (n, j) { n.classList.toggle('active', j === i); });
      slides.forEach(function (s, j) { s.classList.toggle('active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('active', j === i); });
      setBar();
    }
    function reset() {
      if (timer) clearInterval(timer);
      timer = null;
      setBar();
      if (!canAuto()) return;
      timer = setInterval(function () { set((cur + 1) % names.length); }, INT);
    }
    function go(i) { set(i); reset(); }

    names.forEach(function (n) {
      n.addEventListener('mouseenter', function () { go(+n.dataset.i); });
      n.addEventListener('focus', function () { go(+n.dataset.i); });
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.i); }); });
    if (reduce) { if (reduce.addEventListener) reduce.addEventListener('change', reset); else if (reduce.addListener) reduce.addListener(reset); }
    set(0); reset();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-cspot]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
